import React, { useEffect, useState, Component } from 'react';
import AddTemplate from './AddTemplate';
import { Col, Row, Button, Table, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ShopStore, InspectionsStore, CurrentUserStore } from 'stores';
import { Logger } from 'stores/Classes';

function Templates() {
  let history = useHistory();

  const [templates, setTemplates] = useState([]);

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Created At',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (value) => new Date(value).toLocaleString(),
    },
    {
      title: 'Created By',
      key: 'created_by',
      render: (_, record) => `${record.first_name} ${record.last_name}`,
    },
    {
      key: 'action',
      render: (_, record) =>
        CurrentUserStore.allowManager && (
          <div onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="Sure to delete?"
              onConfirm={() => onDelete(record)}
            >
              <DeleteOutlined />
            </Popconfirm>
          </div>
        ),
    },
  ];

  useEffect(() => {
    const initialize = async () => {
      await loadData(ShopStore.currentShop.id);
    };

    initialize();
  }, []);

  useEffect(() => {
    loadData(ShopStore.currentShop.id);
  }, [ShopStore.currentShop.id]);

  const loadData = async (shopId) => {
    try {
      const templates = await InspectionsStore.getTemplates(shopId);

      setTemplates(templates);
    } catch (e) {
      Logger.log(e);
    }
  };

  const onDelete = async (record) => {
    try {
      const formId = record.form_id;
      const shopId = ShopStore.currentShop.id;
      await InspectionsStore.deleteTemplate(shopId, formId);
      const newTemplates = templates.filter(
        (template) => template.form_id !== formId
      );
      setTemplates(newTemplates);
    } catch (e) {
      Logger.log(e);
    }
  };

  return (
    <div>
      <Row style={{ marginBottom: '10px' }}>
        <Col span={12}></Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button
            type="primary"
            onClick={() => history.push('/inspection-forms/templates/add')}
          >
            Create New Template
          </Button>
        </Col>
      </Row>
      <Table
        columns={columns}
        dataSource={templates}
        rowKey="id"
        onRow={(record) => ({
          onClick: () =>
            history.push(`/inspection-forms/templates/${record.form_id}/edit`),
          style: { cursor: 'pointer' },
        })}
      />
    </div>
  );
}

export default observer(Templates);
